import React from 'react';
import PropTypes from 'prop-types';
import {UncontrolledTooltip} from 'reactstrap';
import {FormattedMessage} from 'react-intl';

let counter = 1;
const generateId = () => `tooltip-container-${counter++}`;

class TooltipContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: generateId(),
        };
    }

    render() {
        const {children, component, tooltip, ...props} = this.props;
        const Component = component || 'span';
        return (
            <Component id={this.state.id} {...props}>
                {children}
                <UncontrolledTooltip target={this.state.id}>
                    <FormattedMessage {...tooltip} />
                </UncontrolledTooltip>
            </Component>
        );
    }
}

TooltipContainer.propTypes = {
    children: PropTypes.node,
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    tooltip: PropTypes.object.isRequired,
};

export default TooltipContainer;
